
import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  TeamOutlined,
  UserAddOutlined,
  LineChartOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import AppLayout from '../../components/AppLayout';

const HRDashboard: React.FC = () => {
  const navigate = useNavigate();

  const items = [
    {
      title: 'Recruitment',
      icon: <UserAddOutlined />,
      value: 42,
      description: 'Applications received',
      route: '/hr/recruitment',
    },
    {
      title: 'Employee Lifecycle',
      icon: <TeamOutlined />,
      value: 120,
      description: 'Active employees',
      route: '/hr/employees',
    },
    {
      title: 'Performance',
      icon: <LineChartOutlined />,
      value: 36,
      description: 'Reviews completed',
      route: '/hr/performance',
    },
    {
      title: 'Shift & Attendance',
      icon: <ClockCircleOutlined />,
      value: 95,
      description: 'Check-ins logged',
      route: '/hr/shift-attendance',
    },
    {
      title: 'Expense Claims',
      icon: <DollarOutlined />,
      value: 27,
      description: 'Pending reimbursements',
      route: '/hr/expense-claims',
    },
    {
      title: 'Leaves',
      icon: <CalendarOutlined />,
      value: 18,
      description: 'Pending approvals',
      route: '/hr/leaves',
    },
  ];

  return (
    <AppLayout>
      <Row gutter={[16, 16]}>
        {items.map((item) => (
          <Col xs={24} sm={12} md={8} key={item.title}>
            <Card
              hoverable
              bordered={false}
              onClick={() => navigate(item.route)}
              style={{ borderRadius: 12 }}
            >
              <Statistic
                title={item.title}
                value={item.value}
                prefix={item.icon}
              />
              <p>{item.description}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </AppLayout>
  );
};

export default HRDashboard;